<template>
  <div class="outer-box max-w-xl">
    <h4>Lock Account Features</h4>

    <b-alert show variant="danger" class="text-left m-3">
      This step is irreversible. Blocks SMS sending feature for the subaccount.
      <strong>FOR DEV TEAM ONLY</strong>
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <select class="hl_input--wrap" type="text" v-model="feature">
        <!-- <option value="email">Email</option> -->
        <option value="sms">SMS</option>
      </select>
      <input
        class="mt-4 hl_input--wrap"
        type="text"
        placeholder="Location ID"
        v-model="locationId"
      />
      <button
        class="btn btn-primary mt-4"
        @click="lockFeatureForLocation"
        :disabled="!locationId || isLoading"
      >
        <moon-loader v-if="isLoading" :loading="true" size="21px" color="#fafafa" />
        <span v-else class="capitalize">Lock {{ feature }}</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { EmailISVService } from "@/services";
export default {
  name: "enable-blocked-features",
  data() {
    return {
      locationId: "",
      feature: "sms",
      response: null,
      isLoading: false,
    };
  },
  methods: {
    async lockFeatureForLocation() {
      this.isLoading = true;
      try {
        this.response = await EmailISVService.lockFeature(this.locationId, this.feature);
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>
